import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NVD3Chart from 'react-nvd3';
import hideNVD3Tooltip from '../../utils/hideNVD3Tooltip';


const formatDataForChart = data => {
    const res = [];

    for (const key in data) {
        if (key && data[key] > 0) {
            res.push({ key, value: data[key] });
        }
    }
    return res;
};

const context = {
    valueFormatter: d => d.toFixed(0),
    contentGenerator: d =>
        `<table>
          <tbody>
            <tr>
              <td class="legend-color-guide">
                <div style="background-color: ${d.color};"></div>
              </td>
              <td class="key">${d.data.key}</td>
              <td class="value">${(d.percent * 100).toFixed(0)}%</td>
              <td>(${d.data.value})</td>
            </tr>
          </tbody>
        </table>`,
};

class PieChartComponent extends Component {
    componentWillReceiveProps() {
        hideNVD3Tooltip();
    }

    render() {
        return (
          <div>
            <NVD3Chart
              id="pieChart"
              type="pieChart"
              context={context}
              title={this.props.title}
              datum={formatDataForChart(this.props.data)}
              margin={{}}
              x={ d => (d.key)}
              y={ d => (d.value)}
              showLabels={this.props.labels}
              showLegend={this.props.legend}
              showTooltipPercent={true}
              donut={this.props.donut}
              height={this.props.height || 400}
              tooltip={{
                  valueFormatter: {
                      name: 'valueFormatter',
                      type: 'function',
                  },
                  contentGenerator: {
                      name: 'contentGenerator',
                      type: 'function',
                  },
              }}
            />
          </div>
        );
    }
}

PieChartComponent.propTypes = {
    legend: PropTypes.bool,
    donut: PropTypes.bool,
    labels: PropTypes.bool,
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    height: PropTypes.number,
};

export default PieChartComponent;



/** WEBPACK FOOTER **
 ** ./src/components/charts/PieChartComponent.js
 **/